module.exports = __webpack_public_path__ + "img/pic2.1b6e93c2.jpg";